import { useState, useEffect } from "react";
import axios from "axios";
import { FullContact } from "../types";

export function useColleagues(contactId: string) {
  const [colleagues, setColleagues] = useState<FullContact[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchColleagues = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`/api/clientphonebook/contacts/getColleagues?contactId=${contactId}`);
        setColleagues(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("An error occurred"));
      } finally {
        setLoading(false);
      }
    };

    if (contactId) {
      fetchColleagues();
    }
  }, [contactId]);

  return { colleagues, loading, error };
}
